import { useEffect } from 'react';

import { usePathname, useSearchParams } from 'hooks/navigation';

const FacebookPixelTracker = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!window.fbq) return;
    window.fbq('track', 'PageView');
  }, [pathname, searchParams]);

  return null;
};

export default FacebookPixelTracker;
